export default "__VITE_ASSET__CgUjHzm$__"